import { User } from "../users";
import { z } from "zod";
export const NpmProxyToken = z.object({
    access: z.string(),
    expiresAt: z.number(),
});
export const SessionData = z.object({
    returnToUrl: z.string().optional(),
    npmProxyToken: NpmProxyToken.optional(),
});
export const Session = z.object({
    id: z.string(),
    expiresAt: z.coerce.date(),
    userId: z.string().nullable(),
    anonymousId: z.string().nullable(),
    data: SessionData,
});
export const AuthTokens = z.object({
    access: z.string(),
    refresh: z.string(),
});
export const UserSession = z.object({
    session: Session,
    user: User.nullable(),
});
